import { useEffect, useState } from 'react'
import moment from 'moment'
import { Modal, TimePicker } from 'components/common'
import { CustomizedModalProps } from './types'

export type CheckedUpdateType = 'チェックイン' | 'チェックアウト' | 'クリア'

export interface CheckedStatusUpdateModalProps
  extends Omit<CustomizedModalProps, 'onOk'> {
  date: moment.Moment
  type: CheckedUpdateType
  onOk: (time: moment.Moment) => Promise<void>
  onClose: (visible: boolean) => void
}

export const CheckedStatusUpdateModal = ({
  date,
  type,
  visible,
  onOk,
  onClose,
}: CheckedStatusUpdateModalProps) => {
  const [time, setTime] = useState<moment.Moment>(moment())
  useEffect(() => {
    setTime(moment())
  }, [visible])

  return (
    <>
      <Modal
        title="ステータスの更新"
        visible={visible}
        onOk={() => onOk(time)}
        okText={`${type}する`}
        onCancel={() => onClose(false)}
        cancelText={'キャンセル'}
      >
        {type === 'クリア' ? (
          <p>
            {moment(date).format('YYYY年MM月DD日')}
            のステータスをチェックイン前に戻して本当によろしいでしょうか？
          </p>
        ) : (
          <div>
            {moment(date).format('YYYY年MM月DD日')}の予約を
            <TimePicker
              value={time?.format('HH:mm')}
              onChange={(newTime) => setTime(newTime)}
              className="mx-2"
              style={{ width: '24%' }}
            />
            で{type}しますがよろしいですか。
          </div>
        )}
      </Modal>
    </>
  )
}
